import url from './url'
let AppConsts = {
    userManagement: {
        defaultAdminUserName: 'admin'
    },
    localization: {
        defaultLocalizationSourceName: 'DYYPM'
    },
    authorization: {
        encrptedAuthTokenName: 'enc_auth_token'
    },
    appBaseUrl: "http://localhost:8080",
    fileUrl: 'http://pm.cqdky.com:9903',
    remoteServiceBaseUrl: url
}
switch (process.env.NODE_ENV) {
    case 'development':
        AppConsts.appBaseUrl = "http://localhost:8080"
        break;
    case 'production':
        AppConsts.appBaseUrl = "http://192.168.8.248:9902"
        AppConsts.fileUrl = 'http://pm.cqdky.com:9903'
        break;
}
console.log(process.env.VUE_APP_Url)
if (process.env.VUE_APP_Url) {
    AppConsts.fileUrl = process.env.VUE_APP_Url + ':9903';
    AppConsts.appBaseUrl = process.env.VUE_APP_Url + ':9902';
    AppConsts.remoteServiceBaseUrl = process.env.VUE_APP_Url + ':9903';
}

export default AppConsts;